import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

// Adding stock to one prize.
//
// Nobody chooses where the money comes from. The pot either still fits inside the authorised budget
// or it does not, and the backend answers with that. Asking here would make the person do arithmetic
// the system already knows how to do.

const money = (value) =>
     new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
          maximumFractionDigits: 0,
     }).format(value || 0);

export default function LcvPrizeQuantityIncreaseDialog(props) {
     const { prize, isBusy, onCancel, onConfirm } = props;

     const [quantity, setQuantity] = useState("1");

     const quantityValue = Number(quantity);
     const isQuantityValid = Number.isInteger(quantityValue) && quantityValue > 0;

     return (
          <Dialog open onClose={onCancel} fullWidth maxWidth="sm">
               <DialogTitle>Add stock to {prize?.displayName}</DialogTitle>

               <DialogContent>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                         The pot holds {prize?.totalQty} at {money(prize?.valueGbp)} each.
                         {isQuantityValid && ` Adding ${quantityValue} commits ${money(quantityValue * (prize?.valueGbp || 0))} more.`}
                    </Typography>

                    <TextField
                         label="Quantity to add"
                         type="number"
                         value={quantity}
                         onChange={(event) => setQuantity(event.target.value)}
                         error={quantity !== "" && !isQuantityValid}
                         helperText={
                              quantity !== "" && !isQuantityValid ? "Enter a quantity of 1 or more." : " "
                         }
                         fullWidth
                         autoFocus
                    />
               </DialogContent>

               <DialogActions>
                    <Button type="button" onClick={onCancel} disabled={isBusy}>
                         Cancel
                    </Button>
                    <Button
                         type="button"
                         variant="contained"
                         disabled={!isQuantityValid || isBusy}
                         onClick={() => onConfirm({ prizePotItemId: prize.id, quantity: quantityValue })}
                    >
                         Add stock
                    </Button>
               </DialogActions>
          </Dialog>
     );
}
